"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _Component2 = _interopRequireDefault(require("../../Component"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DropDown = _interopRequireDefault(require("../../DropDown"));

var _listRender = _interopRequireDefault(require("../utils/listRender"));

var _l10n = _interopRequireDefault(require("../../../common/l10n"));

var _escapeRegExp = _interopRequireDefault(require("../../../utils/escapeRegExp"));

var _constants = require("../../DropDown/constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var DropDownSearch =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(DropDownSearch, _Component);

  function DropDownSearch() {
    var _this;

    (0, _classCallCheck2["default"])(this, DropDownSearch);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(DropDownSearch).call(this));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_listRender", function (props) {
      var _this$props = _this.props,
          queryPlaceholder = _this$props.queryPlaceholder,
          attribute = _this$props.attribute,
          style = _this$props.style,
          theme = _this$props.theme;
      return (0, _listRender["default"])(_objectSpread({}, props, {
        list: _this._filter(props.list),
        query: {
          value: _this.state.query,
          onChange: _this._handleQueryChange,
          placeholder: _l10n["default"].translate(queryPlaceholder),
          qaNode: attribute + '-query',
          forwardedRef: _this.queryRef,
          onKeyDown: function onKeyDown(event) {
            return _this._handleQueryKeyDown(event, props.focus);
          },
          style: style && style.input,
          icon: style && style.appearance || theme.appearance,
          theme: theme
        }
      }));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleQueryKeyDown", function (event, focus) {
      if (event.key === _constants.KEY_ARROW_DOWN || event.key === _constants.KEY_ARROW_UP) {
        event.preventDefault();
        focus(event.key === _constants.KEY_ARROW_DOWN ? _constants.LIST_ITEM_POSITION_FIRST : _constants.LIST_ITEM_POSITION_LAST);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleQueryChange", function (event) {
      return _this.setState({
        query: event.target.value
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleOpen", function () {
      _this.focus();

      if (typeof _this.props.onOpen === 'function') {
        var _this$props2;

        (_this$props2 = _this.props).onOpen.apply(_this$props2, arguments);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleClose", function () {
      _this.setState({
        query: ''
      });

      if (typeof _this.props.onClose === 'function') {
        var _this$props3;

        (_this$props3 = _this.props).onClose.apply(_this$props3, arguments);
      }
    });
    _this.state = {
      query: ''
    };
    _this.queryRef = _react["default"].createRef();
    return _this;
  }

  (0, _createClass2["default"])(DropDownSearch, [{
    key: "render",
    value: function render() {
      return _react["default"].createElement(_DropDown["default"], (0, _extends2["default"])({}, this.props, {
        focusListOnOpen: false,
        listRender: this._listRender,
        theme: null,
        onOpen: this._handleOpen,
        onClose: this._handleClose
      }));
    }
  }, {
    key: "focus",
    value: function focus() {
      var _this$queryRef$curren;

      (_this$queryRef$curren = this.queryRef.current) === null || _this$queryRef$curren === void 0 ? void 0 : _this$queryRef$curren.focus();
    }
  }, {
    key: "_filter",
    value: function _filter(list) {
      var query = this.state.query,
          searchFunc = this.props.searchFunc;

      if (query) {
        if (typeof searchFunc === 'function') {
          return searchFunc(query, list) || [];
        } else {
          var pattern = new RegExp((0, _escapeRegExp["default"])(query), 'ig');
          return list.filter(function (item) {
            return pattern.test(item.title || '');
          });
        }
      } else {
        return list;
      }
    }
  }]);
  return DropDownSearch;
}(_Component2["default"]);

(0, _defineProperty2["default"])(DropDownSearch, "defaultProps", {
  queryPlaceholder: 'DROP_SEARCH_QUERY_PLACEHOLDER'
});
(0, _defineProperty2["default"])(DropDownSearch, "propTypes", {
  searchFunc: _propTypes["default"].func,
  queryPlaceholder: _propTypes["default"].string,
  attribute: _propTypes["default"].string,
  style: _propTypes["default"].object,
  onOpen: _propTypes["default"].func,
  onClose: _propTypes["default"].func,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default Search
     */
    appearance: _propTypes["default"].func,

    /**
     * @default 0.38
     */
    appearanceOpacity: _propTypes["default"].number,

    /**
     * @default palette.gutter * 3 + 'px'
     */
    searchPaddingLeft: _propTypes["default"].string,

    /**
     * @default palette.gutter * 3 + 'px'
     */
    searchPaddingRight: _propTypes["default"].string,

    /**
     * @default palette.gutter + 'px'
     */
    searchPaddingTop: _propTypes["default"].string,

    /**
     * @default palette.gutter + 'px'
     */
    searchPaddingBottom: _propTypes["default"].string,

    /**
     * @default 0.87
     */
    hoverAppearanceOpacity: _propTypes["default"].number,

    /**
     * @default 1
     */
    focusAppearanceOpacity: _propTypes["default"].number
  })
});
var _default = DropDownSearch;
exports["default"] = _default;